export enum MultiMembershipActionsButtons {
    AddAccount = 'Add Account',
    EnterCode = 'Enter Code',
    LinkAccounts = 'Link Accounts'
}
